import { useIntersectionObserver } from './useIntersectionObserver';

export const useIsVisible = (elementRef, options, isSSR) => {
  const entry = useIntersectionObserver(elementRef, options || {}, isSSR);
  return !!entry?.isIntersecting;
};
